import React, { Component } from 'react'
import MultiSelect from 'components/common/Form/MultiSelect'
import messages from '../../translate'

class UserSelect extends Component {
  state = {
    selectedUsers: [],
  }

  componentDidMount() {
    this.getActiveUsers()
  }

  componentDidUpdate(prevProps) {
    const { userList } = this.props

    if (prevProps.userList !== userList) {
      this.getActiveUsers()
    }
  }

  onClickSelectItem = value => {
    this.setState(() => ({ selectedUsers: value }))
  }

  getActiveUsers = () => {
    const {
      rowData: { user_ids },
      userList,
    } = this.props
    const users = userList.toArray()

    const selectedUsers = users.filter(item =>
      user_ids.some(userId => item.id === userId),
    )

    this.setState(() => ({ selectedUsers }))
  }

  updateSubscribers = () => {
    const {
      rowData,
      saveMethod,
      activeSite,
      activeLocus,
      formatMessage,
    } = this.props
    const { selectedUsers } = this.state
    const users = selectedUsers.map(item => item.id)
    const params = {}

    if (activeLocus && activeSite) {
      params.site = activeSite
      params.locus = activeLocus
    } else if (activeSite) {
      params.site = activeSite
    }

    saveMethod({
      data: {
        policy: rowData.policy.id,
        users,
        ...params,
      },
      successMessage: formatMessage(messages.subscribersUpdated),
    })
  }

  render() {
    const { userList } = this.props
    const { selectedUsers } = this.state

    return (
      <div className="ma-user-select">
        <MultiSelect
          name="sendTo"
          data={userList.toArray()}
          value={selectedUsers}
          onChange={this.onClickSelectItem}
          onClose={this.updateSubscribers}
        />
      </div>
    )
  }
}

export default UserSelect
